<div class="themes-content" [ngClass]="{'show': !!showThemes}">
  <div>
    <div class="mt20 steps">
      <span class="step-counter">Step {{currentStep + 2}}/{{stepsLength + 2}}</span>
    </div>
    <h1 class="mb20 mt10">Choose your website <span>theme & structure.</span></h1>
    <div class="themes-list">
      <div class="create-ai-assistant-themes__item"
           *ngFor="let theme of themes; let index = index"
           (mouseover)="hovered = index"
           (mouseout)="hovered = -1"
           [ngStyle]="{'borderColor' : (hovered === index && selectedTheme !== theme?.id ? colorToRgba(theme?.btnColor, 0.5) : '')}"
           [ngClass]="{'active': selectedTheme === theme?.id, 'has-selected-item': !!selectedTheme}"
           (click)="selectThemeWithId(theme?.id)">
        <div [ngStyle]="{'background-color': colorToRgba(theme?.btnColor, 0.05)}">
          <div class="create-ai-assistant-themes__item-header ml10">
            <h1 [style.fontFamily]=" '' + theme?.fontFamily + ', sans-serif'">{{theme?.title}}</h1>
            <p [style.fontFamily]=" '' + theme?.fontFamily + ', sans-serif'">{{theme?.description}}</p>
          </div>
          <div class="create-ai-assistant-themes__item-colors">
            <div [style.background-color]="theme?.btnColor"></div>
            <div [style.background-color]="theme?.iconColor"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="button-wrap mb20" *ngIf="!isMobile">
    <button class="ds-btn-black rectangle" [ngClass]="{'ds-btn-disabled': !selectedTemplate || !selectedTheme}" (click)="proceedToNextQuestion()">
      <span>Next</span>
    </button>
    <span class="back mt10" (click)="backToPreviousStep()">Back to previous step</span>
  </div>

</div>
<div class="templates-content {{visibility}}"
     (click)="showThemes = false">
  <div class="templates-wrap"
       [ngClass]="{'one-column': templates?.length === 1, 'two-column': templates?.length === 2, 'four-column': templates?.length === 4}"
       *ngIf="templates.length > 1">
    <ng-container *ngFor="let template of templates">
      <div class="templates-item" [ngClass]="{'active': selectedTemplate === template?.template_id}">
        <div class="templates-btns" [ngClass]="{'visible': visibility === template?.template_id}">
          <button class="ds-btn-black rectangle"
                  [ngClass]="{'selected': selectedTemplate === template?.template_id}"
                  (click)="selectTemplate(template?.template_id)">
            <i class="db-icon db-icon-ds-checkmark"></i>
            <span>Choose</span>
          </button>
        </div>
        <db-create-ai-assistant-template
          [scrollToTop]="visibility !== template?.template_id"
          (click)="selectTemplate(template?.template_id)"
          [newScreenShots]="true"
          [imagesLoading]="imagesLoading"
          (mouseover)="!isMobile ? visibility=template?.template_id : null" (mouseleave)="visibility = null;"
          [theme]="selectedTheme" [template]="template" [selectedTemplate]="selectedTemplate">
        </db-create-ai-assistant-template>
      </div>
    </ng-container>
  </div>
  <div class="button-wrap templates mobile" *ngIf="!!isMobile">
    <span class="back" (click)="backToPreviousStep()">Back to previous step</span>
    <button class="ds-btn-black rectangle"
            [ngClass]="{'ds-btn-disabled': !selectedTemplate || !selectedTheme}"
            (click)="proceedToNextQuestion()">
      <span>Next</span>
    </button>
  </div>

</div>
<div class="db-edit-themes" *ngIf="!!isMobile">
  <div [ngClass]="{'closed': !showThemes}">
    <i class="db-icon db-icon-ds-themes" (click)="showThemes = true" *ngIf="!showThemes"></i>
    <i class="db-icon db-icon-ds-close-bg" (click)="showThemes = false" *ngIf="!!showThemes"></i>
  </div>
</div>
